interface IVideoBorderIconProps {
  style?: React.CSSProperties;
  color?: string;
}

export const MicBorderIcon = ({ style, color = '#0F0F0F' }: IVideoBorderIconProps) => {
  return (
    <div style={{ display: 'flex', ...style }}>
      <svg
        width="12"
        height="18"
        viewBox="0 0 12 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7 8.5V2.5C7 1.94772 6.55228 1.5 6 1.5C5.44772 1.5 5 1.94772 5 2.5V8.5C5 9.05228 5.44771 9.5 6 9.5C6.55228 9.5 7 9.05228 7 8.5ZM6 0C4.61929 0 3.5 1.11929 3.5 2.5V8.5C3.5 9.88071 4.61929 11 6 11C7.38071 11 8.5 9.88071 8.5 8.5V2.5C8.5 1.11929 7.38071 0 6 0Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.25 8.00079C0.25 8.00079 0.25 8 1 8C1.75 8 1.75 7.99932 1.75 7.99932L1.75 7.99796V7.99796L1.75005 8.00225C1.75014 8.00755 1.75034 8.01729 1.7508 8.03117C1.75173 8.05894 1.7537 8.10315 1.75786 8.16141C1.7662 8.27819 1.78325 8.44991 1.81792 8.65795C1.88786 9.07758 2.02634 9.62563 2.29582 10.1646C2.56383 10.7006 2.95408 11.2138 3.5254 11.5947C4.09203 11.9725 4.88124 12.25 6 12.25C7.11876 12.25 7.90797 11.9725 8.4746 11.5947C9.04592 11.2138 9.43617 10.7006 9.70418 10.1646C9.97366 9.62563 10.1121 9.07758 10.1821 8.65795C10.2168 8.44991 10.2338 8.27819 10.2421 8.16141C10.2463 8.10315 10.2483 8.05894 10.2492 8.03117C10.2497 8.01729 10.2499 8.00755 10.2499 8.00225L10.25 7.99932C10.25 7.99932 10.25 8 11 8C11.75 8 11.75 8.00079 11.75 8.00079L11.75 8.00386L11.75 8.00958L11.7498 8.02644C11.7495 8.04006 11.7491 8.05839 11.7484 8.08114C11.7468 8.1266 11.7439 8.18982 11.7383 8.26828C11.7271 8.42494 11.7051 8.64384 11.6617 8.90455C11.5754 9.42242 11.4013 10.1244 11.0458 10.8354C10.6888 11.5494 10.1416 12.2862 9.30665 12.8428C8.46703 13.4025 7.38124 13.75 6 13.75C4.61876 13.75 3.53297 13.4025 2.69335 12.8428C1.85842 12.2862 1.31117 11.5494 0.954179 10.8354C0.598661 10.1244 0.424641 9.42242 0.338329 8.90455C0.294877 8.64384 0.272861 8.42494 0.261671 8.26828C0.256067 8.18982 0.253152 8.1266 0.251637 8.08114C0.250878 8.05839 0.250469 8.04006 0.25025 8.02644L0.250042 8.00958L0.250008 8.00386L0.25 8.00079Z"
          fill={color}
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.25 17.5V13.5H6.75V17.5H5.25Z"
          fill={color}
        />
      </svg>
    </div>
  );
};
